import React from "react";
import {
  formatPhoneNumber,
  DistressRate,
} from "../../common/PropertySummary";
import { formatDate } from "../../../utils/dates";
import { Listing } from "src/types/listing";
import { EnumProductTypes } from "src/types/listing";
import DemographicInfo from "./DemographicInfo";
import PropertyStats from "./PropertyStats";

const PrintListView = ({
  listing,
}: {
  listing: Listing;
}) => {

  const {
    title,
    isDistressed,
    distressedLevel,
    productType
  } = listing;

  return (
    <section className="break-inside-avoid inline-block align-top  break-before-auto">
      <div className=" inline-block flex-col gap-3 mt-4 break-inside-avoid avoidBreakInside  ">
        <div className="break-inside-avoid ">
          {isDistressed && <DistressRate rate={distressedLevel} />}
          <div className="flex group items-center w-full justify-between ">
            <p className=" leading-5 font-[500] text-[14px] text-gray-primary text-wrap	 cursor-pointer">
              <span className="hover:text-primary">{`${title}`}</span>
            </p>

            <p className=" leading-[8.5px] font-[500] text-[8px] text-placeholder text-wrap	 cursor-pointer">
              <span className="hover:text-primary">{`Date Processed: ${listing.formattedPublishDate}`}</span>
            </p>
          </div>
          <PropertyStats listing={listing} variant="compact" />
        </div>

        <div className="grid grid-cols-3 gap-6">
          <div className="col-span-2">
            {productType !== EnumProductTypes.preforeclosure && (
              <section>
                <div className="">
                  <div className="flex gap-4 h-7 items-center  print:mb-0 ">
                    <p className="whitespace-nowrap text-[8px] font-bold leading-3 text-gray-primary">
                      {productType === EnumProductTypes.fsbo
                        ? "Owner Information"
                        : "Tax Information"}
                      <span className="font-[500] text-[12px] text-gray-secondary"></span>
                    </p>{" "}
                    <div className="h-[2px] w-full   bg-gray-300"></div>
                  </div>
                  <div className="grid grid-cols-2 gap-6 ">
                    <div className=" flex flex-col justify-between gap-[6px]">
                      <div className="flex justify-between text-[8px] text-gray-primary leading-[10px] ">
                        <p className="font-semibold">Owner Name:</p>
                        {listing?.ownerContactInfo?.fullName ? (
                          <p className=" text-right">
                            {listing?.ownerContactInfo?.fullName}
                          </p>
                        ) : (
                          <p className="">--</p>
                        )}
                      </div>
                      <div className="flex justify-between text-[8px] text-gray-primary leading-[10px] ">
                        <p className="font-semibold">Phone Number:</p>
                        <p className=" text-right">
                          {" "}
                          {listing.ownerContactInfo.formattedPhone || "--"}
                        </p>
                      </div>
                      <div className="flex justify-between text-[8px] text-gray-primary leading-[10px] ">
                        <p className="font-semibold">Email: </p>
                        <p className=" text-right">
                          {listing?.ownerContactInfo?.email ||
                            "--"}
                        </p>
                      </div>
                    </div>

                    <div className=" flex flex-col  gap-[6px]">
                      {productType !== EnumProductTypes.fsbo && (
                        <div className="flex justify-between text-[8px] text-gray-primary leading-[10px] ">
                          <p className="font-semibold">Mailing Address:</p>

                          {listing?.ownerContactInfo?.address?.streetAddress ? (
                            <p className=" text-right">
                              {listing?.ownerContactInfo.address.formattedAddress}
                            </p>
                          ) : (
                            <p className=" text-right">--</p>
                          )}
                        </div>
                      )}

                      {productType === EnumProductTypes.fsbo && (
                        <div className="flex justify-between text-[8px] text-gray-primary leading-[10px] ">
                          <p className="font-semibold">Owner Address:</p>

                          {listing.ownerContactInfo.address?.formattedAddress ? (
                            <p className=" text-right">
                              {listing.ownerContactInfo.address.formattedAddress}
                            </p>
                          ) : (
                            <p className=" text-right">--</p>
                          )}
                        </div>
                      )}

                      {productType !== EnumProductTypes.fsbo && (
                        <div className="flex justify-between text-[8px] text-gray-primary leading-[10px] ">
                          <p className="font-semibold">Tax ID: </p>
                          <p className=" text-right">
                            {" "}
                            {listing.taxId || "--"}
                          </p>
                        </div>
                      )}

                      <div className="flex justify-between text-[8px] text-gray-primary leading-[10px] ">
                        <p className="font-semibold">Owner Occupied: </p>
                        <p className=" text-right">
                          {" "}
                          {listing.ownerOccupied
                            ? "Yes"
                            : "No"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            )}

            {[EnumProductTypes.expired, EnumProductTypes.oldexpired].includes(
              productType
            ) && (
              <section>
                <div className="">
                  <div className="flex gap-4 h-7 items-center  print:mb-0 ">
                    <p className="whitespace-nowrap text-[8px] font-bold leading-3 text-gray-primary">
                      MLS Information{" "}
                      <span className="font-[500] text-[12px] text-gray-secondary"></span>
                    </p>{" "}
                    <div className="h-[2px] w-full   bg-gray-300"></div>
                  </div>
                  <div className="grid grid-cols-2 gap-6 ">
                    <div className=" flex flex-col justify-between gap-[6px]">
                      <div className="flex justify-between text-[8px] text-gray-primary leading-[10px] ">
                        <p className="font-semibold">MLS ID:</p>
                        <p className=" text-right">
                          {" "}
                          {listing.mlsNumber || "--"}
                        </p>
                      </div>
                      <div className="flex justify-between text-[8px] text-gray-primary leading-[10px] ">
                        <p className="font-semibold">Status: </p>
                        <p className=" text-right">
                          {listing.statusCode || " --"}
                        </p>
                      </div>
                      <div className="flex justify-between text-[8px] text-gray-primary leading-[10px] ">
                        <p className="font-semibold">Status Date: </p>
                        <p className=" text-right">
                          {formatDate(listing.statusDate) || "--"}
                        </p>
                      </div>
                    </div>

                    <div className=" flex flex-col justify-between gap-[6px]">
                      <div className="flex justify-between text-[8px] text-gray-primary leading-[10px] ">
                        <p className="font-semibold">Agent:</p>
                        <p className=" text-right">
                          {listing.listAgent || "--"}
                        </p>
                      </div>
                      <div className="flex justify-between text-[8px] text-gray-primary leading-[10px] ">
                        <p className="font-semibold">Phone: </p>
                        <p className=" text-right">
                          {" "}
                          {formatPhoneNumber(listing.listAgentPhone) ||
                            "--"}
                        </p>
                      </div>
                      <div className="flex justify-between text-[8px] text-gray-primary leading-[10px] ">
                        <p className="font-semibold">Company: </p>
                        <p className=" text-right">
                          {listing.listAgentCompany || "--"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            )}

            {productType === EnumProductTypes.preforeclosure && (
              <section>
                <div className="">
                  <div className="flex gap-4 h-7 items-center  print:mb-0 ">
                    <p className="whitespace-nowrap text-[8px] font-bold leading-3 text-gray-primary">
                      Information{" "}
                      <span className="font-[500] text-[12px] text-gray-secondary"></span>
                    </p>{" "}
                    <div className="h-[2px] w-full   bg-gray-300"></div>
                  </div>
                  <div className="grid grid-cols-2 gap-6 ">
                    <div className=" flex flex-col justify-between gap-[6px]">
                      <div className="flex justify-between text-[8px] text-gray-primary leading-[10px] ">
                        <p className="font-semibold">Mortgage Holder:</p>
                        <p className=" text-right">
                          {" "}
                          {listing.mortgageHolder || "--"}
                        </p>
                      </div>
                      <div className="flex justify-between text-[8px] text-gray-primary leading-[10px] ">
                        <p className="font-semibold">Loan Amount: </p>
                        <p className=" text-right">
                          {listing.formattedLoanAmount}
                        </p>
                      </div>
                      <div className="flex justify-between text-[8px] text-gray-primary leading-[10px] ">
                        <p className="font-semibold">County Recorded: </p>
                        <p className=" text-right">
                          {listing.countyRecorded || "--"}
                        </p>
                      </div>
                      <div className="flex justify-between text-[8px] text-gray-primary leading-[10px] ">
                        <p className="font-semibold">Attorney Name: </p>
                        <p className=" text-right">
                          {listing.attorneyName || "--"}
                        </p>
                      </div>
                    </div>

                    <div className=" flex flex-col justify-between gap-[6px]">
                      <div className="flex justify-between text-[8px] text-gray-primary leading-[10px] ">
                        <p className="font-semibold">Mortgage Date:</p>
                        <p className=" text-right">
                          {listing.formattedMortgageDate || "--"}
                        </p>
                      </div>
                      <div className="flex justify-between text-[8px] text-gray-primary leading-[10px] ">
                        <p className="font-semibold">Delinquent Amount: </p>
                        <p className=" text-right">
                          {" "}
                          {listing.formattedDelinquentAmount || " --"}
                        </p>
                      </div>
                      <div className="flex justify-between text-[8px] text-gray-primary leading-[10px] ">
                        <p className="font-semibold">Date Recorded: </p>
                        <p className=" text-right">
                          {listing.formattedDateRecorded || "--"}
                        </p>
                      </div>
                      <div className="flex justify-between text-[8px] text-gray-primary leading-[10px] ">
                        <p className="font-semibold">Attorney Phone: </p>
                        <p className=" text-right">
                          {listing.formattedAttorneyPhone || "--"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            )}

            {productType === EnumProductTypes.preforeclosure && (
              <section>
                <div className="">
                  <div className="flex gap-4 h-7 items-center  print:mb-0 ">
                    <p className="whitespace-nowrap text-[8px] font-bold leading-3 text-gray-primary">
                      Auction Information{" "}
                      <span className="font-[500] text-[12px] text-gray-secondary"></span>
                    </p>{" "}
                    <div className="h-[2px] w-full   bg-gray-300"></div>
                  </div>
                  <div className="grid grid-cols-2 gap-6 ">
                    <div className=" flex flex-col justify-between gap-[6px]">
                      <div className="flex justify-between text-[8px] text-gray-primary leading-[10px] ">
                        <p className="font-semibold">Trustee Sale Number:</p>
                        <p className=" text-right">
                          {" "}
                          {listing.trusteeSaleNumber || "--"}
                        </p>
                      </div>
                      <div className="flex justify-between text-[8px] text-gray-primary leading-[10px] ">
                        <p className="font-semibold">Auction Location: </p>
                        <p className=" text-right">
                          {listing.auctionLocation || " --"}
                        </p>
                      </div>
                      <div className="flex justify-between text-[8px] text-gray-primary leading-[10px] ">
                        <p className="font-semibold">Min Bid: </p>
                        <p className=" text-right">
                          {listing.formattedAuctionMinimumBid || " --"}
                        </p>
                      </div>
                    </div>

                    <div className=" flex flex-col  gap-[6px]">
                      <div className="flex justify-between text-[8px] text-gray-primary leading-[10px] ">
                        <p className="font-semibold">Auction Date:</p>
                        <p className=" text-right">
                          {listing.formattedAuctionDate || "--"}
                        </p>
                      </div>
                      <div className="flex justify-between text-[8px] text-gray-primary leading-[10px] ">
                        <p className="font-semibold">Owner Occupied: </p>
                        <p className=" text-right">
                          {" "}
                          {listing.ownerOccupied
                            ? "Yes"
                            : "No"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            )}

            {productType === EnumProductTypes.ns && listing.demographics && (
              <DemographicInfo 
                demographics={listing.demographics} 
                variant="compact" 
              />
            )}
          </div>
          <div className="col-span-1 ">
            <div className="flex gap-4 h-7 items-center  print:mb-0 ">
              <p className="whitespace-nowrap text-[8px] font-bold leading-3 text-gray-primary">
                Phone Numbers{" "}
                <span className="font-[500] text-[12px] text-gray-secondary"></span>
              </p>{" "}
              <div className="h-[2px] w-full   bg-gray-300"></div>
            </div>
            <div className="flex flex-col gap-3 pt-1">
              {listing?.contacts && listing.contacts.length > 0 ? (
                listing.contacts.map((contact, index) => (
                  <div key={`print-list-view-contact-${contact.id}`}>
                    <p className="text-[8px] text-gray-primary leading-3">{contact.fullName}</p>{" "}
                    <p
                      className={`text-[8px] ${
                        contact.dnc ? "text-danger" : "text-gray-secondary"
                      } leading-3 `}
                    >{`${formatPhoneNumber(contact?.phone)} ${
                      contact.dnc ? " DNC" : ""
                    }`}</p>{" "}
                  </div>
                ))
              ) : (
                <div>
                  <p className="text-[8px] text-gray-primary leading-3">
                    No phone numbers found.
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
        {[
          EnumProductTypes.fsbo,
          EnumProductTypes.expired,
          EnumProductTypes.oldexpired,
        ].includes(productType) && (
          <section>
            <div className="">
              <div className="flex gap-4 h-7 items-center  print:mb-0 ">
                <p className="whitespace-nowrap text-[8px] font-bold leading-3 text-gray-primary">
                  {productType === EnumProductTypes.fsbo
                    ? "Ad Text"
                    : "Agent Remarks from MLS"}{" "}
                  <span className="font-[500] text-[12px] text-gray-secondary"></span>
                </p>
                <div className="h-[2px] w-full   bg-gray-300"></div>
              </div>
            </div>
            <p className="text-[8px] text-gray-primary leading-[12px] print:text-[10px] print:leading-3 ">
              {productType === EnumProductTypes.fsbo
                ? listing.adText
                : listing.comments}
            </p>
          </section>
        )}

        <section>
          <div className="grid grid-cols-4 gap-4">
            <div className="col-span-1 ">
              <div className="">
                <div className="flex gap-4 h-3 items-center  print:mb-0 ">
                  <p className="whitespace-nowrap text-[8px] font-bold leading-3 text-gray-primary">
                    Showing Instructions{" "}
                    <span className="font-[500] text-[12px] text-gray-secondary"></span>
                  </p>{" "}
                  <div className="h-[2px] w-full   bg-gray-300"></div>
                </div>
              </div>
              <p className="text-[8px] text-gray-primary leading-[12px] print:text-[10px] print:leading-3 ">
                {listing.showingInstructions}
              </p>
            </div>
            <div className="col-span-1 ">
              <div className="">
                <div className="flex gap-4 h-3 items-center  print:mb-0 ">
                  <p className="whitespace-nowrap text-[8px] font-bold leading-3 text-gray-primary">
                    Tags{" "}
                    <span className="font-[500] text-[12px] text-gray-secondary"></span>
                  </p>{" "}
                  <div className="h-[2px] w-full   bg-gray-300"></div>
                </div>
              </div>

              {listing.tags.length ? (
                <div className=" flex flex-wrap gap-2">
                  {listing.tags.map((tag, index) => {
                    return (
                      <div
                        key={`print-list-view-tag-${tag}-${index}`}
                        className="flex items-center justify-between  px-4 gap-1 "
                      >
                        <p className="text-[8px] text-gray-primary leading-[12px] print:text-[10px] print:leading-3 ">
                          {tag}
                        </p>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <p className="text-[8px] text-placeholder leading-[12px] print:text-[10px] print:leading-3 ">
                  No tags found.{" "}
                </p>
              )}
            </div>
            <div className="col-span-2">
              {" "}
              <div className="">
                <div className="flex gap-4 h-3 items-center  print:mb-0 ">
                  <p className=" text-[8px] font-bold leading-3 text-gray-primary">
                    Notes{" "}
                    <span className="font-[500] text-[12px] text-gray-secondary"></span>
                  </p>{" "}
                  <div className="h-[2px] w-full   bg-gray-300"></div>
                </div>
              </div>
              {listing.notes.length > 0 ? (
                <p className="text-[8px] text-gray-primary leading-1 font-normal font-[lato] ">
                  {listing.notes?.[0]?.note}
                </p>
              ) : (
                <p className="text-[8px] text-placeholder leading-[12px] print:text-[10px] print:leading-3 ">
                  No note{" "}
                </p>
              )}
            </div>
          </div>
        </section>
      </div>
    </section>
  );
};

export default PrintListView;
